'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformForInArrayStatement = transformForInArrayStatement;
exports.transformForInObjectStatement = transformForInObjectStatement;
exports.lintForInArrayStatement = lintForInArrayStatement;
exports.lintForInObjectStatement = lintForInObjectStatement;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _blocks = require('./blocks');

var _ref = require('./ref');

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateForInIterator(path, type) {
  var node = path.node;

  var forKwdLoc = (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(node), 3);
  var iterable = node[type];
  var iterableLoc = (0, _astLocUtils.getLoc)(iterable);

  var idx = node.idx || (0, _astLocUtils.placeAtLoc)(_types2.default.clone(path.scope.generateUidIdentifier("i")), forKwdLoc);

  // _i = 0
  var initDeclarations = [(0, _astLocUtils.placeAtNode)(_types2.default.variableDeclarator(idx, (0, _astLocUtils.placeAtNode)(_types2.default.numericLiteral(0), idx)), idx)];

  // (_obj|_arr) = <expr>

  var _undeclaredRef = (0, _ref.undeclaredRef)(path, iterable, type === "object" ? "obj" : "arr"),
      iterableRef = _undeclaredRef.ref,
      declarator = _undeclaredRef.declarator,
      isComplex = _undeclaredRef.isComplex;

  if (isComplex) initDeclarations.unshift(declarator);

  // _keys = Object.keys(_obj)
  var keys = void 0;
  if (type === "object") {
    keys = (0, _astLocUtils.placeAtLoc)(_types2.default.clone(path.scope.generateUidIdentifier("keys")), iterableLoc);
    initDeclarations.push((0, _astLocUtils.placeAtLoc)(_types2.default.variableDeclarator(keys, (0, _astLocUtils.placeAtLoc)(_types2.default.callExpression((0, _astLocUtils.placeAtLoc)(_types2.default.memberExpression((0, _astLocUtils.placeAtLoc)(_types2.default.identifier("Object"), iterableLoc), (0, _astLocUtils.placeAtLoc)(_types2.default.identifier("keys"), iterableLoc)), iterableLoc), [iterableRef]), iterableLoc)), iterableLoc));
  }

  // _len = (_keys | _arr).length
  var len = (0, _astLocUtils.placeAtLoc)(_types2.default.clone(path.scope.generateUidIdentifier("len")), iterableLoc);
  initDeclarations.push((0, _astLocUtils.placeAtLoc)(_types2.default.variableDeclarator(len, (0, _astLocUtils.placeAtLoc)(_types2.default.memberExpression(type === "object" ? keys : iterableRef, (0, _astLocUtils.placeAtLoc)(_types2.default.identifier("length"), iterableLoc)), iterableLoc)), iterableLoc));

  var init = (0, _astLocUtils.placeAtLoc)(_types2.default.variableDeclaration("let", initDeclarations), forKwdLoc);
  // _i < _len
  var test = (0, _astLocUtils.placeAtLoc)(_types2.default.binaryExpression("<", idx, len), forKwdLoc);
  // _i++
  var update = (0, _astLocUtils.placeAtLoc)(_types2.default.updateExpression("++", idx), forKwdLoc);

  (0, _blocks.ensureBlockBody)(path);
  var innerDeclarations = [];
  if (type === "object") {
    // _k = _keys[_i]
    var key = path.node.key || (0, _astLocUtils.placeAtLoc)(_types2.default.clone(path.scope.generateUidIdentifier("k")), iterableLoc);
    innerDeclarations.push((0, _astLocUtils.placeTreeAtLocWhenUnplaced)(_types2.default.variableDeclaration("const", [_types2.default.variableDeclarator(key, _types2.default.memberExpression(keys, idx, true))]), iterableLoc));

    // val = _obj[_k]
    if (path.node.val) {
      innerDeclarations.push((0, _astLocUtils.placeTreeAtLocWhenUnplaced)(_types2.default.variableDeclaration("const", [_types2.default.variableDeclarator(path.node.val, _types2.default.memberExpression(iterableRef, key, true))]), iterableLoc));
    }
  } else {
    // elem = _arr[_i]
    if (path.node.elem) {
      innerDeclarations.push((0, _astLocUtils.placeTreeAtLocWhenUnplaced)(_types2.default.variableDeclaration("const", [_types2.default.variableDeclarator(path.node.elem, _types2.default.memberExpression(iterableRef, idx, true))]), iterableLoc));
    }
  }

  if (innerDeclarations.length > 0) {
    path.get("body").unshiftContainer("body", innerDeclarations);
  }

  return (0, _astLocUtils.placeAtNode)(_types2.default.forStatement(init, test, update, path.node.body), node);
}function transformForInArrayStatement(path) {
  return path.replaceWith(generateForInIterator(path, "array"));
}function transformForInObjectStatement(path) {
  return path.replaceWith(generateForInIterator(path, "object"));
}function toPattern(lvalues) {
  lvalues = lvalues.filter(function (x) {
    return !!x;
  });
  var loc = (0, _astLocUtils.getSurroundingLoc)(lvalues);
  var pattern = (0, _astLocUtils.placeAtLoc)(_types2.default.arrayPattern([]), loc);
  pattern.elements = lvalues;

  return (0, _astLocUtils.placeAtLoc)(_types2.default.variableDeclaration("const", [(0, _astLocUtils.placeAtLoc)(_types2.default.variableDeclarator(pattern), loc)]), loc);
}function lintForInArrayStatement(path) {
  var node = path.node;

  return path.replaceWith((0, _astLocUtils.placeAtNode)(_types2.default.forOfStatement(toPattern([node.idx, node.elem]), node.array, node.body), node));
}function lintForInObjectStatement(path) {
  var node = path.node;

  return path.replaceWith((0, _astLocUtils.placeAtNode)(_types2.default.forOfStatement(toPattern([node.key, node.val]), node.object, node.body), node));
}